import { StoreExt } from '@utils/reactExt'
import { action, observable, runInAction } from 'mobx'
import { message } from 'antd'
import { IAttendVocAnswer, ISendVoc, Schema$VocMaster } from '@protocol/voc'
import { globalStore } from '@store/index'
import { ERR } from 'adv-protocol/src/ErrorCodes'

export class VocStore extends StoreExt {

  @observable
  eventurl: string

  @observable
  isLoading: boolean

  @observable
  vocMaster: Schema$VocMaster

  content: { [type: number]: string } = {}

  checkBox: { [type: number]: boolean } = {}

  select: { [type: number]: number[] } = {}

  phoneNumber: string

  @action
  setLoading(active: boolean) {
    this.isLoading = active
  }

  @action
  async getVocInfo() {
    try {
      this.setLoading(true)
      const result = await this.api.voc.getVocInfo({})
      runInAction(() => {
        this.eventurl = result.vocUrl
        this.vocMaster = result.vocMatser
        this.setLoading(false)
      })
    } catch (err) {
      console.error(err)
      message.error('voc info error', err)
    }
  }

  async sendVoc() {
    try {
      const params: ISendVoc.Params = {
        answers: {
          phoneNumber: this.phoneNumber,
          content: this.content,
          checkBox: this.checkBox,
          select: this.select
        }
      }

      const result = await this.api.voc.sendAnswer(params)
      const { errcode } = result
      if (errcode) {
        switch (errcode) {
          case ERR.USER_NOT_FOUND:
            globalStore.pushDialogOk({ title: '알림', text: ['회원가입시 입력한 핸드폰 번호를', '기입해 주세요'], className: 'small-size' })
            break
          case ERR.ALREADY_LOGGEDIN:
            globalStore.pushDialogOk({ title: '알림', text: ['중복으로 참여할 수 없습니다.'], className: 'small-size' })
            break
          case ERR.DATA_NOT_FOUND:
            globalStore.pushDialogOk({
              title: '알림', text: ['이벤트가 종료되었습니다.'], className: 'small-size',
              callbackCloseDialog: () => {
                window.location.reload()
              }
            })
            break
        }
      } else if (result.ok) {
        globalStore.pushDialogOk({
          title: '알림', text: ['참여해 주셔서 감사합니다.'], className: 'small-size',
          callbackCloseDialog: () => {
            window.location.href = `${process.env.FRONTEND_BASE_URL}:${process.env.FRONTEND_PORT}`
          }
        })
      }
    } catch (err) {
      console.error(err)
      message.error('voc send Error', err)
    }
  }

  setPhoneNumber(phoneNumber: string) {
    this.phoneNumber = phoneNumber
  }

  setContent(type: number, content: string) {
    this.content[type] = content
  }

  setChecked(type: number, check: boolean) {
    this.checkBox[type] = check
  }

  setSelect(type: number, selects: number[]) {
    this.select[type] = selects
  }

  @action
  async attendVoc() {
    try {
      await this.api.voc.attendVoc({})
    } catch (err) {
      console.error(err)
      message.error('attendVoc Error', err)
    }
  }

  async attendVocAnswer(content: string, checkBox: boolean) {
    try{
      const params: IAttendVocAnswer.Params = {
        content,
        checkBox,
      }

      const result = await this.api.voc.attendVocAnswer(params)
      const { errcode } = result
      if (errcode) {
        switch (errcode) {
          case ERR.ALREADY_LOGGEDIN:
            globalStore.pushDialogOk(
              { wrapClassName:'am-modal-wrap-z-index-top',
                title: '알림', text: ['중복으로 참여할 수 없습니다.'], className: 'small-size' })
            break
          case ERR.DATA_NOT_FOUND:
            globalStore.pushDialogOk({
              wrapClassName:'am-modal-wrap-z-index-top',
              title: '알림', text: ['이벤트가 종료되었습니다.'], className: 'small-size'
            })
            break
        }
      } else if(result.ok) {
        globalStore.pushDialogOk({
          wrapClassName:'am-modal-wrap-z-index-top',
          title: '알림', text: ['참여해 주셔서 감사합니다.'], className: 'small-size'
        })
      }
    } catch (err) {
      console.error(err)
      message.error('attendVocAnswer Error', err)
    }
  }
}

export default new VocStore()
